// Common or repeated strings
export const commonTranslations = {
    en: {
        next: "Next",
        previous: "Previous",
    },
    es: {
        next: "Siguiente",
        previous: "Anterior",
    },
    de: {
        next: "Weiter",
        previous: "Zurück",
    },
    fr: {
        next: "Suivant",
        previous: "Précédent",
    },
    it: {
        next: "Successivo",
        previous: "Precedente",
    },
    ja: {
        next: "次へ",
        previous: "戻る",
    },
    pt: {
        next: "Próximo",
        previous: "Anterior",
    },
};
